import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { buildWhatsappUrl } from "@/lib/whatsapp";

export default function WhatsAppFloat() {
  const { t } = useLang();
  const text = t({
    es: "Hola SACRVM, quiero más información sobre sus mezcales / Private Label.",
    en: "Hi SACRVM, I'd like more information about your mezcals / Private Label.",
  });
  return (
    <motion.a
      data-testid="whatsapp-float"
      href={buildWhatsappUrl(text)}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.6, duration: 0.8, ease: [0.19, 1, 0.22, 1] }}
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[color:var(--sacrvm-gold)]/40 blur-lg group-hover:blur-xl transition-all" />
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[color:var(--sacrvm-gold)] text-black hover:bg-white transition-colors duration-500">
        <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
          <path d="M20.52 3.48A11.9 11.9 0 0 0 12 0C5.37 0 0 5.37 0 12a11.85 11.85 0 0 0 1.64 6.06L0 24l6.11-1.6A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.21-3.48-8.52ZM12 22a9.94 9.94 0 0 1-5.06-1.38l-.36-.22-3.63.95.97-3.54-.23-.36A9.95 9.95 0 1 1 22 12c0 5.52-4.48 10-10 10Zm5.47-7.5c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.66.15s-.75.97-.92 1.17c-.17.2-.34.22-.63.07-.3-.15-1.26-.46-2.4-1.47-.89-.79-1.49-1.77-1.66-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.34.44-.51.15-.17.2-.29.3-.49.1-.2.05-.37-.02-.52-.07-.15-.66-1.59-.9-2.18-.24-.58-.49-.5-.66-.51h-.56c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.87 1.21 3.07c.15.2 2.09 3.2 5.07 4.49.71.31 1.26.5 1.69.64.71.23 1.36.2 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z" />
        </svg>
      </span>
      <span className="hidden md:inline-block absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-black/85 backdrop-blur-md text-white text-[11px] tracking-[0.22em] uppercase px-3 py-2 border border-white/10 opacity-0 group-hover:opacity-100 transition-opacity">
        {t({ es: "Habla con nosotros", en: "Talk to us" })}
      </span>
    </motion.a>
  );
}
